import $ from 'jquery';

// Bootstrap 4 integration
import "datatables.net-autofill-bs4";
import 'datatables.net-bs4';
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-fixedheader-bs4";
import "datatables.net-responsive-bs4";

// Optional extensions (uncomment if needed)
// import "datatables.net-colreorder-bs4";
// import "datatables.net-keytable-bs4";
// import "datatables.net-responsive-bs4";
// import "datatables.net-rowgroup-bs4";
// import "datatables.net-rowreorder-bs4";
// import "datatables.net-scroller-bs4";
// import "datatables.net-select-bs4";

// Global settings for DataTables
$.extend($.fn.dataTable.defaults, {
  responsive: true,
  paging: true
});

export function initialize_datatables(selector, options = {}) {
  if ($(selector).length === 0) return;

  if (!$.fn.DataTable.isDataTable(selector)) {
    // Default configuration
    const defaultConfig = {
      ordering: true,
      columnDefs: [
        { className: "text-left", targets: "_all" }
      ],
      layout: {
        topEnd: {
          search: {
            text: '',
            placeholder: 'Search tenant...'
          }
        },
        topStart: 'buttons',
        bottomStart: 'info',
        bottomEnd: {
          paging: {
            buttons: 5,
            type: 'full_numbers'
          }
        }
      },
      buttons: [
        {
          extend: 'csv',
          text: '<i class="far fa-save"></i> Download CSV',
          filename: $(selector).data('filename'),
          className: 'button-secondary__active',
        },
      ],
    };

    // Handle snapshots page customizations
    if (options.hideDownloadButton) {
      defaultConfig.buttons = [];
      defaultConfig.layout.topStart = null;
    }

    // Handle search position customization
    if (options.searchPosition === 'topLeft') {
      defaultConfig.layout.topStart = {
        search: {
          text: '',
          placeholder: 'Search tenant...'
        }
      };
      defaultConfig.layout.topEnd = null;
    }

    $(selector).DataTable(defaultConfig);
  }
}

// Set AJAX source dynamically before DataTables initialization
$(document).on("preInit.dt", (e, settings) => {
  let api = new $.fn.dataTable.Api(settings);
  let table_id = `#${api.table().node().id}`;
  let url = $(table_id).data("source");
  if (url) {
    api.ajax.url(url);
  }
});

// Initialize DataTables on Turbo Drive (formerly Turbolinks) page load
document.addEventListener("turbo:load", () => {
  if (!$.fn.DataTable.isDataTable("table[id^=dttb-]")) {
    $("table[id^=dttb-]").DataTable();
  }
});

// Handle Turbo Drive cache issue
document.addEventListener("turbo:before-cache", () => {
  let dataTable = $($.fn.dataTable.tables(true)).DataTable();
  if (dataTable !== null) {
    dataTable.clear();
    dataTable.destroy();
  }
});
